/* eslint-disable */
import React from 'react';

function LayoutTele(props) {
  return (
    <div className="w-full flex">
      {props.children}
    </div>
  );
}

export default LayoutTele;
